import { render, staticRenderFns } from "./Bays.vue?vue&type=template&id=6f7cd1da&"
import script from "./Bays.vue?vue&type=script&lang=js&"
export * from "./Bays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports